import React from 'react';
import styles from './store-component.module.scss';
import { useSelector } from 'react-redux';
import { Language } from '_types/language';
import { languageSelector } from 'store-modules/app-settings/app-settings.selectors';
import { returnCopyForLanguage } from 'services/language-service';
import classNames from 'classnames';

interface ViewCopy {
    downloadInfo: string;
    infoText: string;
}

const nbCopy: ViewCopy = {
    downloadInfo: 'Nesten ferdig!',
    infoText: 'Du må laste ned appen for å kunne starte et abonnement.',
};
const enCopy: ViewCopy = {
    downloadInfo: 'Almost done!',
    infoText: 'You must download the app to start a subscription.',
};
const copies: { name: Language; copy: ViewCopy }[] = [
    {
        name: 'nb',
        copy: nbCopy,
    },
    {
        name: 'en',
        copy: enCopy,
    },
];

const StoreComponent: React.FC = () => {
    const language: Language = useSelector(languageSelector);
    const { downloadInfo, infoText } = returnCopyForLanguage(language, copies);

    return (
        <div className={styles.StoreComponent}>
            <section className={styles.header}>{downloadInfo}</section>
            <section className={styles.InfoText}>{infoText}</section>
            <section>
                <a
                    href='https://apps.apple.com/us/app/fuelbox/id1507438424?itsct=apps_box_link&itscg=30200'
                    target='_blank'
                    rel='noopener noreferrer'
                    tabIndex={0}
                    role='button'
                    className={classNames(styles.AppStoreBadgeContainer)}
                >
                    <div className={styles.AppStoreBadge}></div>
                </a>
                <a
                    href='https://play.google.com/store/apps/details?id=no.fuelbox.fuelbox&hl=no&gl=US'
                    target='_blank'
                    rel='noopener noreferrer'
                    tabIndex={0}
                    role='button'
                    className={classNames(styles.GooglePlayStoreBadgeContainer)}
                >
                    <div className={styles.GooglePlayStoreBadge}></div>
                </a>
            </section>
        </div>
    );
};

export default StoreComponent;
